import { PopoverTrigger as ChakraPopoverTrigger } from '@chakra-ui/react';

const PopoverTrigger = (props: { children: React.ReactNode }) => <ChakraPopoverTrigger {...props} />;

export default PopoverTrigger;
